import React from "react";
import { Container } from "@mui/material";
import { WrappersMain } from "./styles/WrappersStyle";

const Wrappers = (props) => {
  return (
    <>
      <Container maxWidth="lg">
        <WrappersMain>{props.children}</WrappersMain>
      </Container>
    </>
  );
};

export default Wrappers;
